import React from 'react';

export default class CCAdminRegistration extends React.Component {
  render() {
    return null;
  }
}
